import { useTranslation } from 'react-i18next';
import { GLOBAL_NAVIGATION_HEIGHT } from '@/shared/lib/constants';
import { useRouteSidePanelStore } from '@/shared/stores/side-panel-store';
import { Banner } from '@/shared/ui';
import { SideMenuHeader } from '@/widgets/right-side-menu/ui/SideMenuHeader';
import { useMasterData } from '../master-table/use-master-data';
import { MasterCreateForm } from './MasterCreateForm';

/**
 * マスタ新規追加・編集サイドパネル
 *
 * マスタテーブルの「新規追加」ボタンまたは「編集」ボタン押下時に表示されるコンテナ。
 * editTarget の有無で新規追加/編集モードを切り替える。
 */
export const MasterCreateSidePanel = () => {
  const { t } = useTranslation();
  const requestClose = useRouteSidePanelStore((state) => state.requestClose);
  const mode = useRouteSidePanelStore((state) => state.mode);

  const modeData = mode?.type === 'settlement-statistics-converter.master' ? mode : undefined;

  // 既存マスタデータを取得（Autocomplete候補用）
  const { data: existingData } = useMasterData({
    resultId: modeData?.convertResultId ?? '',
    masterType: modeData?.masterType ?? 'expenditure_purpose',
  });

  return (
    <div
      className="flex flex-col overflow-hidden"
      style={{ height: `calc(100vh - ${GLOBAL_NAVIGATION_HEIGHT}px)` }}
    >
      <SideMenuHeader
        onClose={() => {
          requestClose();
        }}
      />
      {modeData ? (
        <MasterCreateForm
          // editTargetの変更を検知してフォームをリセットするためのキー
          key={modeData.editTarget?.id ?? 'create'}
          convertResultId={modeData.convertResultId}
          masterType={modeData.masterType}
          existingData={existingData}
          editTarget={modeData.editTarget}
          onClose={requestClose}
        />
      ) : (
        <Banner
          type="error"
          title={t('common.status.error')}
          description={t('common.status.no-data')}
        />
      )}
    </div>
  );
};
